import { useTranslation } from "react-i18next";

import { styled } from "styled-components";

import { RichTextViewer } from "simplydo/react/richtext";
import { Icon, Message } from "simplydo/react/ui";

import { FieldProps } from "./FieldProps";

export const InfoTextHeader = styled.div`
  font-size: 9px;
  color: gray;
  text-align: right;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  > h3 {
    margin: 0;
    display: block;
    font-size: 1.5em;
  }
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e9ebee;
`;

type CustomInfoTextProps = { field: FieldProps["field"] };

const CustomInfoText = ({ field }: CustomInfoTextProps) => {
  const { t } = useTranslation();
  return (
    <Message>
      <InfoTextHeader>
        <Icon name="info circle" color="grey" size="big" />
        <h3>{t("ideas.custom.supporting.info")}</h3>
      </InfoTextHeader>
      <RichTextViewer value={field.content ?? ""} />
    </Message>
  );
};

export default CustomInfoText;
